import { getBlogs, getTools } from 'sagas/network'
import { Tool } from '@diversioteam/diversio-ds/dist/components/core/SolutionsTab/components/Tools/tools.types'

import { Queries } from 'api/queries.enum'
import { GetBlogsResponse, GetToolsResponse } from 'api/actions/home/solutions/solutionsActions.types'
import { transformThumbnailUrl } from 'utils/transformThumbnailUrl/transformThumbnailUrl'

import { useQuery } from './useQuery'

export const useGetSolutions = () => {
    const blogsQuery = useQuery<GetBlogsResponse, Error>({
        queryKey: [Queries.getBlogs],
        queryFn: getBlogs,
        select: (data) =>
            data.map((blog) => ({
                ...blog,
                thumbnail: transformThumbnailUrl(blog.thumbnail),
            })),
    })

    const toolsQuery = useQuery<GetToolsResponse, Error, Tool[]>({
        queryKey: [Queries.getTools],
        queryFn: getTools,
        select: (data) =>
            data.map((tool) => ({
                ...tool,
                mediaType: tool.mediaType?.toLowerCase() as Tool['mediaType'],
                targetGroup: tool.targetGroups.join(', '),
            })),
    })

    return {
        blogsQuery,
        toolsQuery,
    }
}
